export const addItem = {
  data () {
    return {
      items: []
    }
  },
  methods: {
    add (params) {
      let counter = this.items.length + 1
      let attr = params || {}
      let newItem = {
        id: counter,
        new: true
      }
      if (attr) {
        newItem = {...newItem, ...attr}
      }
      this.items.push(newItem)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/addItem.js